import React, { useState } from "react";
import Swal from "sweetalert2";
import api from "../../utils/api";

const ChangePassword: React.FC = () => {
const [values, setValues] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
    showCurrent: false,
    showNew: false,
    showConfirm: false,
});

const handleChange =
    (prop: keyof typeof values) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
        setValues({ ...values, [prop]: event.target.value });
    };

const handleClickShowPassword = (prop: "showCurrent" | "showNew" | "showConfirm") => {
    setValues({ ...values, [prop]: !values[prop] });
};

const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
};

const handleSubmit = async (event: React.FormEvent) => {
    const userId = localStorage.getItem("selectedUserId") ?? "";
    event.preventDefault();
    // Handle password change logic here
    if (values.newPassword !== values.confirmPassword) {
        Swal.fire({
            title: "Error",
            text: "New password and confirm password do not match.",
            icon: "error",
            confirmButtonText: "OK"
        });
    } else {
        if(userId === ""){
            Swal.fire({
                title: "Error",
                text: "User ID not found.",
                icon: "error",
                confirmButtonText: "OK"
            });
            return;
        }
        try {
            const response = await api.put("/api/Auth/ChangePassword", {
                userId: userId,
                newPassword: values.newPassword
            });
            // Assuming the API returns a success status
            if(response.status !== 200) {
                Swal.fire({
                    title: "Error",
                    text: "Failed to change password.",
                    icon: "error",
                    confirmButtonText: "OK"
                });
                return;
            }else{
                Swal.fire({
                    title: "Success",
                    text: "Password changed successfully.",
                    icon: "success",
                    confirmButtonText: "OK"
                });
                setValues({
                    currentPassword: "",
                    newPassword: "",
                    confirmPassword: "",
                    showCurrent: false,
                    showNew: false,
                    showConfirm: false,
                });
            }
        } catch {
            Swal.fire({
                title: "Error",
                text: "Network error. Please try again.",
                icon: "error",
                confirmButtonText: "OK"
            });
        }
    }
};

return (
    <div className='page-body'>
        <div className="d-flex justify-content-center align-items-center min-vh-80" style={{ backgroundColor: "#f5f6fa", minHeight: "80vh" }}>
            <div className="card shadow" style={{ width: 400, padding: "2rem" }}>
                <h5 className="card-title fw-bold mb-3">Change Password</h5>
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label className="form-label">New Password</label>
                        <div className="input-group">
                            <input
                                type={values.showNew ? "text" : "password"}
                                className="form-control"
                                value={values.newPassword}
                                onChange={handleChange("newPassword")}
                                required
                            />
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => handleClickShowPassword("showNew")}
                                onMouseDown={handleMouseDownPassword}
                                tabIndex={-1}
                            >
                                <i className={`fa ${values.showNew ? "fa-eye-slash" : "fa-eye"}`}></i>
                            </button>
                        </div>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Confirm New Password</label>
                        <div className="input-group">
                            <input
                                type={values.showConfirm ? "text" : "password"}
                                className="form-control"
                                value={values.confirmPassword}
                                onChange={handleChange("confirmPassword")}
                                required
                            />
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => handleClickShowPassword("showConfirm")}
                                onMouseDown={handleMouseDownPassword}
                                tabIndex={-1}
                            >
                                <i className={`fa ${values.showConfirm ? "fa-eye-slash" : "fa-eye"}`}></i>
                            </button>
                        </div>
                    </div>
                    <button type="submit" className="btn btn-primary w-100 mt-2">
                        Change Password
                    </button>
                </form>
            </div>
        </div>
    </div>
);
};

export default ChangePassword;